<script lang="ts" setup>
import { MAPBOX_LAYER_SPECIFICATION_PROVIDE_INJECT, MAPBOX_PROVIDE_INJECT, IAD_PARIS, useSafePosition } from '~/composables/mapbox/map';
import type { MapBoxInjected, UnsafeLgnLat } from '~/composables/mapbox/map';

const props = withDefaults(
  defineProps<{
    containerId?: string
    center?: UnsafeLgnLat
  }>(),
  {
    containerId: `iad-mapbox-layer-specification`,
    center: () => IAD_PARIS,
  },
);
const { position: safePosition } = useSafePosition(toRef(props, `center`));
const layerSpecification = shallowRef<mapboxgl.LayerSpecification>();
// Allows nesting Layer specifications by giving children a way to hook into Layer instance
provide(MAPBOX_LAYER_SPECIFICATION_PROVIDE_INJECT, { layerSpecification });
const { mapbox } = inject(MAPBOX_PROVIDE_INJECT) as MapBoxInjected;

const source = shallowRef<mapboxgl.SourceSpecification>();

watch(mapbox, () => {
  if (!mapbox.value) return;
  // NOTE: Immediate to been trigger during tests
  // Without this
  // • since “provide” will be injected before “mount’
  source.value = {
    type: 'geojson',
    data: {
      type: 'FeatureCollection',
      features: [
        {
          properties: {
            'property-location': 'property-location',
          },
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: safePosition.value,
          },
        },
      ],
    },
  };

  mapbox.value.on('load', () => {
    if (!mapbox.value || !source.value) return;
    mapbox.value.addSource(props.containerId, source.value);
  });
}, { immediate: true });

onBeforeUnmount(() => {
  if (!mapbox.value) return;
  mapbox.value.removeLayer(props.containerId);
  mapbox.value.removeSource(props.containerId);
});
</script>

<template>
  <div class="contents">
    <div
      :id="containerId"
      v-bind="$attrs"
    />
    <slot />
  </div>
</template>
